import { ChangeDetectionStrategy, Component, inject, type Signal } from "@angular/core";
import { toSignal } from "@angular/core/rxjs-interop";
import { TranslateModule } from "@ngx-translate/core";
import { CustomToastService} from "@shared/services/custom-toast/custom-toast.service";
import { ToastDataModel } from "@core/models/toast-data.model";

@Component({
  selector: "app-custom-toast",
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: "./custom-toast.component.html",
  styleUrls: ["./custom-toast.component.scss"],
  imports: [TranslateModule],
})
export class CustomToastComponent {
  private readonly customToastService: CustomToastService = inject(CustomToastService);

  /**
   * `toSignal` en vez de la suscripcion manual: la lista la reemplaza el
   * servicio desde un `setTimeout`, asi que con OnPush hacia falta senal.
   * Tambien se cancela sola al destruir el componente.
   */
  readonly toasts: Signal<ToastDataModel[]> = toSignal(this.customToastService.toasts$, {
    initialValue: [],
  });

  onToastClick(toast: ToastDataModel): void {
    if (toast.onClickCallback) toast.onClickCallback();
  }
}
